import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-66">
          <div className="shrink-0" data-id="element-67">
            <div className="w-32 h-32 md:w-48 md:h-48 bg-brand-orange/10 rounded-full flex items-center justify-center border border-brand-orange/30" data-id="element-68">
              <ShieldAlert className="w-16 h-16 md:w-24 md:h-24 text-brand-orange" data-id="element-69" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-70">
            <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-71">
              Garantía Blindada de 7 Días
            </h2>
            <p className="text-lg md:text-xl text-brand-muted leading-relaxed" data-id="element-72">
              Prueba el protocolo por 7 días. Si no sientes un cambio real en tu
              energía, te devolvemos tu dinero sin preguntas.{' '}
              <strong className="text-white" data-id="element-73">El riesgo es nuestro.</strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}